import { GetTopLevelItems } from "@utils/factsHelpers/getTopLevelItems";

import {
  FactsStructureType_insuranceHandbookPageCollection_items,
  FactsStructureType_insuranceHandbookPageCollection_items_childrenPagesCollection_items,
} from "globalQueries/contentfulTypes/FactsStructureType";
import { UrlStructureItem } from "types/UrlStructureItem";

export const FactsUrlStructureFactory = (
  array: Array<FactsStructureType_insuranceHandbookPageCollection_items>,
): UrlStructureItem[] => {
  const flatStructure: UrlStructureItem[] = [];
  const urls = getFactsUrlStructure(array, flatStructure);

  return urls;
};

const getFactsUrlStructure = (
  array: Array<FactsStructureType_insuranceHandbookPageCollection_items>,
  flatStructure: UrlStructureItem[],
): UrlStructureItem[] => {
  const topLevelItems = GetTopLevelItems(array);

  topLevelItems?.forEach((item) => {
    getFactsUrlStructureRecursive(array, item?.slug, flatStructure, "");
  });
  return flatStructure;
};

const getFactsUrlStructureRecursive = (
  array: Array<FactsStructureType_insuranceHandbookPageCollection_items>,
  itemSlug: string,
  flatStructure: UrlStructureItem[],
  parentUrl: string,
): UrlStructureItem[] => {
  const item = array?.filter((a) => a?.slug === itemSlug)[0];
  if (!item || !item?.slug || !item?.name) return;
  let urlSlug: string = "";
  urlSlug = `${parentUrl}/${item?.slug}`;

  const children = item?.childrenPagesCollection?.items
    ? item?.childrenPagesCollection?.items
    : ([] as Array<FactsStructureType_insuranceHandbookPageCollection_items_childrenPagesCollection_items>);
  if (children && children?.length) {
    children?.map(
      (
        child: FactsStructureType_insuranceHandbookPageCollection_items_childrenPagesCollection_items,
      ) => {
        getFactsUrlStructureRecursive(array, child?.slug, flatStructure, urlSlug);
      },
    );
  }

  flatStructure.push({
    slug: item?.slug,
    url: "/forsakringshandboken" + urlSlug,
    name: item?.name,
  });
  return flatStructure;
};
